const annotationsFields = `
  id
  fontSize
  height
  optional
  pageNumber
  signerId
  type
  width
  x
  y
`;

export const signableFields = `
  id
  annotations {
    ${annotationsFields}
  }
  canBeEdited
  canBeVoided
  createdAt
  lastSyncAt
  name
  originalFiles {
    order
    uri
    url
  }
  pdfUrl
  pendingSignature
  provider
  signableTemplateId
  status
  syncStatus
  updatedAt
  url
  signers {
    id
    company
    email
    jobTitle
    lastEvent
    name
    photo
    roleName
    status
    type
  }
`;

export const signableSignFields = `
  ${signableFields}
  annotations {
    ${annotationsFields}
    value
  }
`;

export const signableRoomListingFields = `
  id
  name
  pendingSignature
  status
  syncStatus
  url
  signers {
    email
    lastEvent
    name
    status
  }
`;

// third parties
export const envelopeFields = `
  id
  name
  sender
  created
  lastModified
  signers {
    email
    name
    roleName
    status
  }
`;

export const signablesTemplateListingFields = `
  id
  annotations {
    ${annotationsFields}
  }
  createdAt
  createdBy {
    id
    fullName
    username
  }
  description
  files {
    order
    uri
    url
  }
  name
  signablesCount
  signers {
    id
    email
    name
    roleName
  }
  updatedAt
  updatedBy {
    fullName
    username
  }
`;
